import { isEmpty } from './isEmpty'

export const replacePlaceHolderString = (text: string, data: any) => {
    if (!isEmpty(text) && !isEmpty(data)) {
        const placeholders = text.match(/[^{\}]+(?=})/g)
        text = text.replace(/[{}]/g, '')
        if (!isEmpty(placeholders) && placeholders !== null) {
            placeholders.forEach((item, index) => {
                text = text.replace(placeholders[index], data[placeholders[index]])
            })
        }
    }
    return text
}
